import Vue from "vue";
import MessageBase from "./MessageBase.vue";
import appVue from "@/main.js";

export class MessageManager {
  static messageBase = null;

  static getMessageBase() {
    return this.messageBase ?? this.loadMessageBase();
  }

  static loadMessageBase() {
    let mbase = Vue.extend(MessageBase);
    this.messageBase = new mbase({
      parent: appVue,
    });
    let mountPoint = document.getElementById("message-mount");
    this.messageBase.$mount();
    let messageDom = this.messageBase.$el;
    mountPoint.appendChild(messageDom);
    return this.messageBase;
  }
  static message(message) {
    if (message) {
      this.getMessageBase().addMessage(message);
    }
  }
}

export default function (message) {
  if (message) {
    MessageManager.message(message);
  }
}